var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Sales",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-sales","viewBox":"0 0 100 100"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M50 100C22.386 100 0 77.614 0 50S22.386 0 50 0s50 22.386 50 50-22.386 50-50 50zm0-4c25.405 0 46-20.595 46-46S75.405 4 50 4 4 24.595 4 50s20.595 46 46 46zm2.525-27.761v4.716c0 1.08-1.022 2.045-2.303 2.045-1.342 0-2.366-.965-2.366-2.045v-4.659c-2.75-.229-5.628-1.022-8.251-2.046C37.367 65.399 35 64.093 35 62.274c0-1.308.958-2.045 2.111-2.045 1.663 0 2.813 1.022 4.22 1.647 2.687 1.25 5.311 1.931 9.02 1.931 5.886 0 8.956-2.046 8.956-5.057 0-3.181-2.944-4.601-10.298-6.818C38.58 48.81 35.51 45.97 35.51 40.74c0-5.51 4.99-8.409 12.6-9.034v-4.659c0-1.077.962-2.046 2.305-2.046 1.343 0 2.367.969 2.367 2.046v4.716c2.238.113 4.477.683 6.524 1.307 2.367.797 4.54 1.706 4.54 3.353 0 1.136-.703 2.046-2.303 2.046-.573 0-1.151-.17-1.598-.343-3.198-1.249-5.885-2.1-9.53-2.1-5.437 0-9.146 1.477-9.146 4.714 0 3.296 2.427 4.319 9.977 6.705C59.753 50.115 65 52.33 65 58.41c0 5.341-4.223 8.864-12.475 9.829z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/sales.svg